{
  "decrease": "Smanji {fieldLabel}",
  "increase": "Povećaj {fieldLabel}",
  "numberField": "Polje broja"
}
